import React from 'react'

import * as styles from '@/components/form/form.module.scss'
import { useSiteMetadata } from '@/components/root-element'

import CheckboxToogle from './checkboxToogle'

const Terms: React.FC = () => {
  const { settings } = useSiteMetadata()
  const { 'terms-of-use': termsOfUse, 'privacy-policy': privacyPolicy } =
    settings
  return (
    <div className={styles.termsBox}>
      <CheckboxToogle id="terms" label={termsOfUse as string} />
      <CheckboxToogle id="privacy" label={privacyPolicy as string} />
    </div>
  )
}
export default Terms
